import { useEffect, useRef } from "react";
import QRCode from "react-qr-code"; // Import QRCode component

function QrCodeGenerator({ url, link }: any) {
	const qrCodeRef = useRef<HTMLDivElement | null>(null);
	const canvasRef = useRef<HTMLCanvasElement | null>(null);



	useEffect(() => {
		if (qrCodeRef.current && canvasRef.current) {
			const svg = qrCodeRef.current.querySelector("svg");
			if (svg) {
				const xml = new XMLSerializer().serializeToString(svg);
				const svg64 = btoa(xml);
				const image64 = `data:image/svg+xml;base64,${svg64}`;
				const img = new Image();
				img.src = image64;
				img.onload = () => {
					const canvas: any = canvasRef.current;
					const ctx = canvas.getContext("2d");
					if (ctx) {
						ctx.clearRect(0, 0, canvas.width, canvas.height);
						// Draw white background
						ctx.fillStyle = "black";
						ctx.fillRect(0, 0, canvas.width, canvas.height);
						// Draw QR code
						ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
					}
				};
			}
		}
	}, [url]);

	// const downloadQRCode = () => {
	// 	if (canvasRef.current) {
	// 		const image = canvasRef.current.toDataURL("image/png");
	// 		const link = document.createElement("a");
	// 		link.href = image;
	// 		link.download = "qrcode.png";
	// 		link.click();
	// 	}
	// };


	return (
		<div className="qrcode__container">
			<div className="qrcode__container--parent" ref={qrCodeRef}>
				{link && (
					<div className="qrcode__download">
						<QRCode value={url} size={300} />
						<canvas ref={canvasRef} width={300} height={300} style={{ display: 'none' }}></canvas>
						{/* <button onClick={downloadQRCode} className="admin-btn-progress mt-4">Download QR Code</button> */}
					</div>

				)}
			</div>
		</div>
	);
}
export default QrCodeGenerator;
